import { ColumnDef, Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { DataTable } from "../../../../component-library";
import { Invoice } from "../../../../models";
import { displayDate } from "../../../../helper-functions";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../../lists";
import { InvoiceDashboardViews } from ".";

interface InvoicingDashboardInvoicesProps {
    invoices: Invoice[];
    view: InvoiceDashboardViews;
}

export function InvoicingDashboardInvoices({ invoices, view }: InvoicingDashboardInvoicesProps) {
    const navigate = useNavigate();
    const isReady = view === InvoiceDashboardViews.InvoicesReady;
    const list = isReady ? Lists.InvoicesReadyForQbo : Lists.InvoicesFlagged;

    const columns = useMemo<ColumnDef<Invoice>[]>(
        () => [
            {
                header: "Invoice",
                accessorFn: (invoice) => invoice.name,
            },
            {
                header: "Billing Account",
                accessorFn: (invoice) => invoice.account?.name,
            },
            {
                header: "Surgeon",
                accessorFn: (invoice) =>
                    invoice.surgery?.surgeon
                        ? `${invoice.surgery.surgeon.firstName} ${invoice.surgery.surgeon.lastName}`
                        : "",
            },
            {
                header: "Surgery Date",
                accessorFn: (invoice) => displayDate(invoice.surgery?.scheduledOnUtc),
            },
            {
                header: "Recipient",
                accessorFn: (invoice) => {
                    const firstName = invoice.surgery?.recipientFirstName ?? "";
                    const lastName = invoice.surgery?.recipientLastName ?? "";
                    return `${firstName} ${lastName}`.trim();
                },
            },
        ],
        []
    );

    if (!invoices.length) {
        return <div>No invoices found</div>;
    }

    return (
        <DataTable
            columns={columns}
            data={invoices}
            paginated={invoices.length > 10}
            showGlobalFilter
            onRowClick={(row: Row<Invoice>) => navigate(`/lists/${list}/invoices/${row.original.id}`)}
        />
    );
}
